<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span style="color: white;">
            {{NoteTitle}}
        </span>
        <button [attr.guide]="'crm-note-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style="margin: 0px; padding: 0px;">
        <div class="padding-11">
            <div fxLayout="column" style="overflow: auto;" [formGroup]="firstFormGroup">

                <div *ngIf="noteId==0" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                    <mat-form-field *ngIf="crmType == 1" appearance="outline" class="custom-form-field" fxFlex>
                        <mat-label>Template</mat-label>
                        <mat-select formControlName="template" [disableOptionCentering]="true" #singleSelect
                            autocomplete="off">
                            <mat-option>
                                <ngx-mat-select-search name="template Search" ngDefaultControl
                                    [formControl]="typeYFilterControl" placeholderLabel="template Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let opt of filteredTemplateTypeList; let i=index;"
                                [value]="opt.templateId" (onSelectionChange)="setTemplate($event,opt)">
                                {{ opt.templateName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>

                <div *ngIf="Notetype!=3" class="Description">

                    <div class="mention-wrapper" *ngIf="crmType != 1">
                        <div class="notes-editor-container" [class.notes-focused]="notesFocused"
                            (click)="notesTextarea.focus()">
                            <label class="notes-editor-label">{{ Notetype === 1 ? 'Description' : 'Notes' }} *</label>
                            <div #notesTextarea class="notes-editor" contenteditable="true" (input)="onNotesInput()"
                                (keyup)="onNotesKeyUp($event)" (focus)="notesFocused = true" (blur)="onNotesBlur()">
                            </div>
                        </div>
                        <span class="notes-editor-error" *ngIf="showNotesError">Please fill out this field.</span>

                        <!-- @mention autocomplete dropdown -->
                        <div *ngIf="showMentionDropdown" class="mention-dropdown">
                            <div *ngFor="let u of mentionFilteredUsers" class="mention-option"
                                (mousedown)="onOptionMousedown($event, u)">
                                <span class="mention-avatar">{{ (u.email || '?')[0].toUpperCase() }}</span>
                                <div class="mention-info">
                                    <div class="mention-name">{{ u.email }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="crmType == 1">
                        <calsoft-doc-editor formControlName="notes" [mode]="'compose'"></calsoft-doc-editor>
                    </div>

                </div>

                <div *ngIf="Notetype==2" class="Description">

                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                        <mat-form-field fxFlex="50" appearance="outline">
                            <mat-label>Document Type</mat-label>
                            <mat-select formControlName="documentType">
                                <mat-option *ngFor="let status of documentType" [value]="status.value">
                                    {{status.viewValue}}
                                </mat-option>
                            </mat-select>

                        </mat-form-field>

                    </div>


                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                        <div fxFlex="50" *ngIf="firstFormGroup.value.documentType==1">
                            <calsoft-video-upload fxFlex="100" [finalValue]="firstFormGroup.value.notesDocument"
                                (sendValue)="getValue($event)">
                            </calsoft-video-upload>

                        </div>
                        <div fxFlex="50" *ngIf="firstFormGroup.value.documentType==2">
                            <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.notesDocument"
                                (sendValue)="getValue($event)">

                            </calsoft-audio-upload>
                        </div>

                        <div fxFlex="50" *ngIf="firstFormGroup.value.documentType==3">
                            <calsoft-course-pdf-upload fxFlex="100" [finalValue]="firstFormGroup.value.notesDocument"
                                (sendValue)="getValue($event)"></calsoft-course-pdf-upload>
                        </div>

                        <div fxFlex="50" *ngIf="firstFormGroup.value.documentType==4">
                            <calsoft-image fxFlex="100" [finalValue]="firstFormGroup.value.notesDocument"
                                (sendValue)="getValue($event)">
                            </calsoft-image>

                        </div>
                    </div>

                </div>

                <div *ngIf="Notetype==3" class="Description">

                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Payment Amount</mat-label>
                        <input [attr.guide]="'crm-note-inp-notes' + '__' + sanitizeUrl(url)" type="text" disabled
                            [autocomplete]="'off'" trim="blur" matInput formControlName="notes" />
                        <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                    <button [attr.guide]="'crm-note-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-raised-button
                        (click)="close()">Cancel
                    </button>

                    <ng-container *ngIf="Notetype!=3">
                        <button [attr.guide]="'crm-note-btn-3' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                            (click)="submit()" mat-raised-button>
                            {{text}}
                            <mat-icon *ngIf="text !='Save' ">
                                <mat-spinner color="primary" diameter="20">
                                </mat-spinner>
                            </mat-icon>
                        </button>
                    </ng-container>

                    <ng-container *ngIf="Notetype==3">
                        <button [attr.guide]="'crm-note-btn-4' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                            (click)="submitPayment()" mat-raised-button>
                            {{text}}
                            <mat-icon *ngIf="text !='Save' ">
                                <mat-spinner color="primary" diameter="20">
                                </mat-spinner>
                            </mat-icon>
                        </button>
                    </ng-container>
                </div>

                <div>
                    <br>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>